export default __webpack_public_path__ + "static/media/use3.d03155b0.png";